module.exports = __webpack_public_path__ + "img/credit-card.17414d7e.svg";